import { apiClient } from './client';

/**
 * Client for `GET /api/compliance/audit-log`. Mirrors the response shape
 * exactly — keep this in lockstep with
 * `server/src/routes/compliance/auditLog.routes.ts`.
 */

export type AuditAction =
  | 'create'
  | 'update'
  | 'delete'
  | 'sign'
  | 'approve'
  | 'view_sensitive'
  | 'export'
  | 'ai_invoke';

export interface AuditLogEntry {
  id: string;
  occurredAt: string;
  action: AuditAction;
  entityType: string;
  entityId: string | null;
  actorEmailSnapshot: string;
  actorNameSnapshot: string;
  actorRoleSnapshot: string;
  beforeJson: unknown;
  afterJson: unknown;
  reasonForChange: string | null;
  signatureMeaning: string | null;
  ipAddress: string | null;
  userAgent: string | null;
}

export interface AuditLogPage {
  data: AuditLogEntry[];
  total: number;
  limit: number;
  offset: number;
}

export interface AuditLogQuery {
  action?: AuditAction;
  entityType?: string;
  entityId?: string;
  actorEmail?: string;
  /** YYYY-MM-DD or ISO datetime. */
  since?: string;
  /** YYYY-MM-DD or ISO datetime. */
  until?: string;
  limit?: number;
  offset?: number;
}

export async function listAuditLog(q: AuditLogQuery = {}): Promise<AuditLogPage> {
  const params = new URLSearchParams();
  if (q.action) params.set('action', q.action);
  if (q.entityType) params.set('entityType', q.entityType);
  if (q.entityId) params.set('entityId', q.entityId);
  if (q.actorEmail) params.set('actorEmail', q.actorEmail);
  if (q.since) params.set('since', q.since);
  if (q.until) params.set('until', q.until);
  if (typeof q.limit === 'number') params.set('limit', String(q.limit));
  if (typeof q.offset === 'number') params.set('offset', String(q.offset));
  const query = params.toString() ? `?${params.toString()}` : '';
  const res = await apiClient.get<AuditLogPage>(`/api/compliance/audit-log${query}`);
  return res.data;
}
